import { render, staticRenderFns } from "./crud_component.vue?vue&type=template&id=7ba5c4a6"
import script from "./crud_component.vue?vue&type=script&lang=js"
export * from "./crud_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports